import React, { useEffect, useState } from 'react';
import { Chart } from 'primereact/chart';
import { ChartData, ChartOptions } from 'chart.js';
import { useTranslation } from 'react-i18next';

// register.ts
import {
  Chart as ChartJS,
  BarElement,
  PointElement,
  LineElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title,
} from 'chart.js';

ChartJS.register(
  BarElement,
  PointElement,
  LineElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title
);

interface BarDistributionChartProps {
  data: ChartData;
  options: ChartOptions;
}

export function BarDistributionChart(props: BarDistributionChartProps) {
  const { i18n } = useTranslation();

  const [chartData, setChartData] = useState<ChartData>(props.data);
  const [chartOptions, setChartOptions] = useState<ChartOptions>(props.options);
  useEffect(() => {
    setChartData(props.data);
    setChartOptions(props.options);
  }, [i18n.language, props.data, props.options]);

  return (
    <Chart
      style={{
        height: '50vh', // 50% de la altura de la ventana
        width: '100%', // 100% del ancho disponible
      }}
      data={chartData}
      options={chartOptions}
    />
  );
}

export default BarDistributionChart;
